export interface CurrencyConfig {
  currencySymbol: string;
  decimalSeparator: string;
  thousandsSeparator: string;
  currencySymbolBefore: boolean;
}

const unitedStatesConfig: CurrencyConfig = {
  currencySymbol: '$',
  decimalSeparator: '.',
  thousandsSeparator: ',',
  currencySymbolBefore: true,
};

const configs: Record<string, CurrencyConfig> = {
  'en-US:USD': unitedStatesConfig,
  'en-AU:AUD': unitedStatesConfig,
  'en-CA:CAD': unitedStatesConfig,
  'en-NZ:NZD': unitedStatesConfig,
  'fr-CA:CAD': {
    // 12 345 678,00 $
    currencySymbol: ' $',
    decimalSeparator: ',',
    thousandsSeparator: ' ',
    currencySymbolBefore: false,
  },
  'da-DK:DKK': {
    // 1.234.567.890,00 kr.
    currencySymbol: ' kr.',
    decimalSeparator: ',',
    thousandsSeparator: '.',
    currencySymbolBefore: false,
  },
  'en-GB:GBP': {
    // £1,234,567,890.00
    currencySymbol: '£',
    decimalSeparator: '.',
    thousandsSeparator: ',',
    currencySymbolBefore: true,
  },
  'nb-NO:NOK': {
    // kr 1 234 567 890,00
    currencySymbol: 'kr ',
    decimalSeparator: ',',
    thousandsSeparator: ' ',
    currencySymbolBefore: true,
  },
  'sv-SE:SEK': {
    // 1.234.567.890,00 kr
    currencySymbol: ' kr',
    decimalSeparator: ',',
    thousandsSeparator: '.',
    currencySymbolBefore: false,
  },
};

function getCurrencyConfiguration(bcp47LanguageTag: string, iso4217CurrencyCode: string) {
  const config = configs[`${bcp47LanguageTag}:${iso4217CurrencyCode}` as keyof typeof configs];

  if (!config) {
    console.warn(`No currency configuration found for '${bcp47LanguageTag} ${iso4217CurrencyCode}'; defaulting to 'en-US USD'`);

    return unitedStatesConfig;
  }

  return config;
}

export default getCurrencyConfiguration;
